import { render, staticRenderFns } from "./ERC.vue?vue&type=template&id=b872936c&"
import script from "./ERC.vue?vue&type=script&lang=js&"
export * from "./ERC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports